/** マーカー種別 */
export const MARKER_TYPE = {
  /** 住家被害認定調査 */
  residentialDamage: 'residentialDamage',
  /** 応急危険度判定調査 */
  emergency: 'emergency',
  /** AI倒壊判定 */
  aiCollapse: 'aiCollapse'
} as const
